(function () {
  'use strict'

  require('dynamic-bind-html')
  require('./scss/description.scss')

  const MODULE_NAME = 'thismoment.card.component.description'
  const templateUrl = require('./tpl/description.html')

  require('angular')
    .module(MODULE_NAME, [
      'dynamicBindHtml', // ಠ_ಠ
      require('angular-sanitize'),
      require('../../analytics'),
      require('../../content'),
      require('../../expandedContent')
    ])
    .component('thismomentDescription', {
      require: {
        parent: '^thismomentCard'
      },
      bindings: {
        allowHtml: '<',
        ccmtContentId: '<',
        customStyles: '<',
        description: '@',
        linkOut: '<',
        trackEvent: '&'
      },
      templateUrl: templateUrl,
      controller: descriptionController
    })

  descriptionController.$inject = ['SdkConfig', '$scope', '$element', '$timeout']
  function descriptionController (SdkConfig, $scope, $element, $timeout) {
    const vm = this
    vm.toggle = toggleExpand
    vm.$postLink = descriptionInit
    function descriptionInit () {
      vm.styles = {
        text: {},
        fadeout: {}
      }

      vm.displayLinkOut = vm.linkOut.link && vm.linkOut.label

      $scope.$on('carousel:activated', () => {
        vm.carousel = true
      })

      $timeout(() => {
        var $el = $element[0].children[0].children[0]
        vm.expandable = !vm.displayLinkOut && $el.scrollHeight > $el.clientHeight
        if (vm.expandable) {
          vm.styles.text['-webkit-line-clamp'] = 7
        }
      })

      if (Object.prototype.hasOwnProperty.call(vm.customStyles, 'background-color')) {
        vm.styles.fadeout = {
          background: 'linear-gradient(to bottom, rgba(255,255,255,0) 0%,' + vm.customStyles['background-color'] + ' 100%)'
        }
      }

      if (Object.prototype.hasOwnProperty.call(vm.customStyles, 'color')) {
        vm.styles.text.color = vm.customStyles.color
      }
    }

    function toggleExpand () {
      if (vm.carousel || !SdkConfig.get('is_mobile')) {
        vm.parent.expand()
      } else {
        if (!vm.expanded) {
          vm.trackEvent({
            action: 'Content Expanded',
            properties: {
              'event trigger': 'clicked arrow'
            }
          })
        }
        vm.expanded = !vm.expanded
        $timeout(() => {
          $scope.$emit('grid:refresh')
        }, 100)
      }
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/card/component/description.js